export const surveyWidgetStateSelector = ({ surveyWidgetModel: { surveyWidgetState } }) => ({
    isSurveyWidgetLoaded: surveyWidgetState === 'loaded',
    isSurveyWidgetReady: surveyWidgetState === 'ready',
});
export const surveyUrlSelector = ({ surveyWidgetModel: { surveyParams } }) => surveyParams.url;
export const isSurveyReadySelector = ({ surveyWidgetModel: { surveyParams } }) => {
    const { url, isReady } = surveyParams;
    return Boolean(url);
};
